module.exports = __webpack_public_path__ + "img/chevron_right_black.d14e7df6.svg";